import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

// Shared chrome for client-detail list tabs (Figma 2889:57355 Quotes pattern).
export const clientTabCardShadow =
  'shadow-[0px_8px_16px_-4px_rgba(38,45,66,0.1),0px_1px_4px_-4px_rgba(38,45,66,0.05)]'

export const clientTabTableShadow =
  'shadow-[0px_1px_4px_0px_rgba(38,45,66,0.05)]'

export const clientTabFilterTriggerClass =
  'h-10 w-auto shrink-0 min-w-[120px] justify-between gap-2 rounded-xl border-[#e7e9ef] bg-white py-3 pl-4 pr-3 text-sm font-normal leading-6 text-[#171a20] focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 data-[state=open]:ring-0 [&>span]:font-normal [&>span]:leading-6 [&>span>span]:font-normal [&_svg]:size-4'

export const clientTabFilterOptionClass = 'text-sm font-normal'

export const clientTabSearchInputClass =
  'h-10 w-full max-w-[240px] rounded-xl border-[#e7e9ef] bg-white pl-10 pr-4 text-sm font-normal placeholder:font-normal placeholder:text-[#3d434e]'

export const clientTabPrimaryBtnClass =
  'h-10 gap-2 rounded-xl border border-[#ff5a1f] bg-[#ff5a1f] p-3 text-sm font-medium leading-none text-white hover:bg-[#e6511c] [&_svg]:size-4'

export const clientTabOutlineBtnClass =
  'h-10 gap-2 rounded-xl border border-[#e7e9ef] bg-white px-3 py-3 text-sm font-medium leading-none text-[#171a20] hover:bg-[#f4f5f8]'

export const clientTabViewDetailsBtnClass =
  'inline-flex items-center gap-2 rounded-lg p-2 text-sm font-medium leading-none text-[#ff5a1f] hover:bg-[#fff1ea]'

export const clientTabActionBtnClass =
  'inline-flex shrink-0 items-center justify-center rounded-lg p-2 text-[#171a20] hover:bg-[#fff1ea]'

export const clientTabThClass =
  'h-10 border-b border-[#e7e9ef] bg-[#fbfbfc] px-3 py-2 text-[10px] font-medium uppercase leading-[14px] tracking-normal text-[#3d434e]'

export const clientTabTdClass =
  'h-16 border-b border-[#e7e9ef] px-3 py-2 align-middle text-sm'

export const clientTabFirstTdClass =
  'h-16 border-b border-[#e7e9ef] px-3 py-2 align-middle text-sm relative before:absolute before:bottom-0 before:left-0 before:top-0 before:w-1 before:bg-primary before:opacity-0 before:transition-opacity group-hover:before:opacity-100'

/** Pin the actions column to the right edge of the table. */
export const clientTabActionsColClass = 'text-right'

export const clientTabActionsThClass = cn(
  clientTabThClass,
  clientTabActionsColClass
)

export const clientTabActionsTdClass = cn(
  clientTabTdClass,
  clientTabActionsColClass
)

export const clientTabActionsCellClass =
  'ml-auto flex w-full items-center justify-end gap-1'

export function ClientTabSection({
  title,
  headerAction,
  toolbar,
  children,
  className,
}: {
  title: ReactNode
  headerAction?: ReactNode
  toolbar?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <section
      className={cn(
        'flex w-full flex-col overflow-hidden rounded-2xl border border-[#e7e9ef] bg-white',
        clientTabCardShadow,
        className
      )}
    >
      <header
        className={cn(
          'flex shrink-0 items-start gap-2 pr-6 pt-6 pb-2',
        )}
      >
        <div className='flex min-w-0 flex-1 items-center border-l-4 border-[#ff5a1f] px-6'>
          <h2 className='font-heading text-sm font-semibold leading-[1.2] text-[#171a20]'>
            {title}
          </h2>
        </div>
        {headerAction ? <div className='shrink-0'>{headerAction}</div> : null}
      </header>

      <div className='flex flex-col gap-4 px-6 pb-6 pt-4'>
        {toolbar}
        {children}
      </div>
    </section>
  )
}
